module.exports = __webpack_public_path__ + "common/icon-singlecolor-e28c6b6ecf6937193821fbc56cc0539f.svg";